/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 12:25:23
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import setChart2 from './chart2';
import Chart from '../components/Chart';
import { Title35 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';
import Form2 from './Form2';

class P35 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],
      chartTitle2: [],
      chartList2: [],
      chartColorList2: [],
    }
  }

  render() {
    const { chartTitle, chartList, chartColorList,  chartTitle2, chartList2, chartColorList2 } = this.state;
    return (
      <Stage>
        <Title35 pageNumber="">5.4 伊利VS蒙牛 | 单日传播效果涨跌对比与关键动作
        </Title35>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.des}>
              倒计时100天节点，伊利传播效果优于蒙牛。4月17日，伊利达到单日数字口碑价值最高峰：<span className={s.emphasis}>195,367,107<i>DB</i></span> ，为监测期内单日平均DB值的19.60倍。
            </div>
            <div contentEditable className={s.des}>
              蒙牛“得分点”有两个：①王一博、吴磊发博，倡导运动生活，让蒙牛在5月16日达到单日数字口碑价值最高峰：<span className={s.emphasis}>274,646,305<i>DB</i></span> ，为监测期内单日
            平均DB值的24.38倍。②多个代言人担任火炬手。
            </div>
          </div>

          <div className={s.uiWrapper}>
            <div className={s.chartWrapper1}>
              <TooltipDrawer
                  style={{ width: '100%', height: '100%' }}
                  formContent={<Form onChange={values => this.setState({ ...values })} />}>
                  <Chart options={setChart({
                    label: chartTitle,
                    list: chartList,
                    color: chartColorList
                  })} />
                </TooltipDrawer>
            </div>
            <div className={s.chartWrapper2}>
              <TooltipDrawer
                  style={{ width: '100%', height: '100%' }}
                  formContent={<Form2 onChange={values => this.setState({ ...values })} />}>
                  <Chart options={setChart2({
                    label: chartTitle2,
                    list: chartList2,
                    color: chartColorList2
                  })} />
                </TooltipDrawer>
            </div>
          </div>
        </div>
        <div contentEditable className={s.explain}>
          数据说明：本页图表数据观测窗口为2023年1月1日-12月31日。数据来源：新闻媒体类（中央级媒体/泛财经媒体/行业媒体/大众媒体）+资讯网媒+新闻客户端（今日头条/一点资讯等）+自媒体平台（微信号等）+社交平台（微博/知乎等）+短视频类（抖音/快手/视频号/B站等）+消费种草社区（小红书/什么值得买/得物App等）+垂类体育社区（虎扑/懂球帝/Keep等）+其它论坛贴吧等。
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P35);



// WEBPACK FOOTER //
// src/routes/visualChart/P35/index.js